// import env from './config/env';
import Vue from 'vue';
import vuetify from './plugins/vuetify';
import iView from 'view-design';
import VueRouter from 'vue-router';
import VModal from './vuetify_custom/vModal'
import VueQrcode from 'qrcode.vue';
import { path_arr_vue } from './router';
import VueDomPortal from 'vue-dom-portal';
import store from './vuex/store'
import math from 'mathjs'
import moment from 'moment'
import echarts from 'echarts'
import Util from './libs/util';
import Rule from './libs/rule';
import './libs/extension';
import "regenerator-runtime/runtime.js";
import './kindeditor/kindeditor-all-min';
import 'jsondiffpatch/dist/formatters-styles/html.css';
import './libs/compatibility'
import walden from './../static/walden.json'

import App from './app.vue';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import 'view-design/dist/styles/iview.css';
// import './mytheme/year.less';
import './css/iview-modify.css';
import './css/vuetify-modify.less';
import './css/animate.css';
import './css/common.css';
import './css/font.css';

// 监控配置
const BrowserLogger = require('alife-logger');
const bl_config = {
  pid: "arfwkpr6mb@e7a51aa2fcd137d",
  appType: "web",
  imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
  sendResource: true,
  enableLinkTrace: true,
  behavior: true,
  enableSPA: true,
  useFmp: true,
  ignore: {
    ignoreUrls: [
      () => {
        const host = window.location.host || '';
        return !(host.indexOf('baicizhan.com') >= 0);
      }
    ]
  },
};
const user_id = localStorage.getItem('user-id');
if (user_id) {
  bl_config.uid = user_id;
}
const __bl = BrowserLogger.singleton(bl_config);
window.__bl = __bl;
import Space from './views/common/space.vue'
import AjaxBtn from './views/components/ajax_btn.vue'
import Backdrop from './views/components/backdrop.vue'
import RichText from './views/components/kind_editor.vue'
import QRScaner from './views/components/qr_scaner.vue'
import UserFlow from './views/components/flow/user_flow.vue'
import CustomerPoptip from './views/components/customer/poptip';
import FinExpenseTypeEdit from './views/fin_report/components/fin_expense_type_edit.vue';
import CourseDataTypeEdit from './views/course_report/components/course_data_type_edit.vue';

Set.prototype.get = function(index) {
  const arr = [...this]
  return arr[index]
}

Vue.use(VModal)
Vue.use(VueRouter);
Vue.use(VueDomPortal)
// Vue.use(VueI18n);
Vue.use(iView, {
  transfer: true,
  modal: {
    maskClosable: false
  }
});

// 全局组件
Vue.component('Space', Space);
Vue.component('Ajaxbtn', AjaxBtn);
Vue.component('Backdrop', Backdrop);
Vue.component('RichText', RichText);
Vue.component('qrcode', VueQrcode);
Vue.component('qr-scaner', QRScaner);
Vue.component('UserFlow', UserFlow);
Vue.component('FinExpenseTypeEdit', FinExpenseTypeEdit);
Vue.component('CourseDataTypeEdit', CourseDataTypeEdit);
Vue.component('CustomerPoptip', CustomerPoptip);
Vue.component('CustomerName', (resolve) => require(['./views/components/customer/name.vue'], resolve));

// 自动设置语言
const navLang = navigator.language;
const localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : false;
const lang = window.localStorage.getItem('language') || localLang || 'zh-CN';

Vue.config.lang = lang;
Vue.config.keyCodes = {
  enter: 13
}

// 多语言配置
// const locales = Locales;
// const mergeZH = Object.assign(zhLocale, locales['zh-CN']);
// const mergeEN = Object.assign(enLocale, locales['en-US']);
// Vue.locale('zh-CN', mergeZH);
// Vue.locale('en-US', mergeEN);

// 开发模式配置
// if(env === 'production'){
//     console.log = function(){};
// }
// 路由配置
// console.log('path_arr_vue',path_arr_vue)
const RouterConfig = {
  mode: 'history',
  routes: path_arr_vue.filter(item => item.noChkout)// 将不需要鉴权的路由注入vue-router中
};
const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  next();
});

router.afterEach(() => {
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});
// 为echarts注册主题
// console.log('walden',walden)
// console.log( JSON.parse(walden))
echarts.registerTheme('walden', walden)

//JavaScript精确计算
math.config({number: 'BigNumber'});
window.math = math;

//日期格式化
moment.locale('ZH-cn');
window.moment = moment;

// window.$ = $;
window.Util = Util;
Vue.prototype.$util = Util;
Vue.prototype.$rule = Rule;
Vue.prototype.$http = Util.http;
// window.Clipboard = clipboard;
// window.Html2canvas = html2canvas;
window.KindEditor = KindEditor;
KindEditor.ready(function(K) {
  window.kindEditor = K;
  window.eventHub = new Vue();
  new Vue({
    el: '#app',
    router: router,
    store: store,
    vuetify,
    render: h => h(App)
  });
});
